import { styled } from '@mui/material/styles';
import { List } from '@mui/material';

export const StyledHealthClaimList = styled(List)({
  display: 'grid',
  gridTemplateColumns: '240px 240px 240px 240px',
  fontSize: '14px',
  fontWeight: 400,
  fontFamily: 'Open Sans'
});

export const StyledHealthClaimListItem = styled('div')(({ index }: { index: number }) => ({
  display: 'flex',
  gridRowStart: index < 24 ? (index % 6) + 1 : (index % 6) + 7
}));
